import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { State, Mutation } from "vuex-class";
let SysContentHeader = class SysContentHeader extends Vue {
    handleClose(item, index) {
        if (this.sys.toData.path == item.url) {
            let url = "";
            if (index === 0) {
                url = this.sys.goRouter[index + 1].url;
            }
            else {
                url = this.sys.goRouter[index - 1].url;
            }
            this.$router.push(url);
        }
        this.UP_GOROUTER(index);
    }
    tagClick(item) {
        this.$router.push(item.url);
    }
};
__decorate([
    State("sys")
], SysContentHeader.prototype, "sys", void 0);
__decorate([
    Mutation("UP_GOROUTER")
], SysContentHeader.prototype, "UP_GOROUTER", void 0);
SysContentHeader = __decorate([
    Component
], SysContentHeader);
export default SysContentHeader;
